//@flow

import * as React from 'react';
import styled from 'styled-components';

const StyledSpinnerWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.moduleColor ? props.moduleColor : 'none'};
  cursor: wait;
`;

const StyledSpinner = styled.div`
	margin: 50px auto 0;
	border-top: 12px solid #265a9c50;
	border-right: 12px solid #265a9c50;
	border-bottom: 12px solid #265a9c50;
	border-left: 12px solid #265a9c;
	animation: animation 1.1s infinite linear;
	border-radius: 50%;
	width: 60px;
	height: 60px;

  @keyframes animation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
`;

const Spinner = (props: any): React.Node => (
  <StyledSpinnerWrapper {...props}>
    <StyledSpinner />
  </StyledSpinnerWrapper>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.jsx